import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api/BanksApi';
import { getFiBankStore } from 'stores/FiBankStore';
import { STAFF_KEY } from './consts';
import { useUser } from './useUser';

export function useStaff({ shouldNotifyOnChange = true }: { shouldNotifyOnChange?: boolean } = {}) {
  const banksApi = new BanksApi();
  const bankStore = getFiBankStore();
  const { userBankId } = useUser();

  const { data: staff, isLoading: isLoadingStaff } = useQuery({
    enabled: !!userBankId.length,
    queryKey: [STAFF_KEY, userBankId],
    queryFn: () => banksApi.getBankStaff(userBankId),
    ...(!shouldNotifyOnChange && { notifyOnChangeProps: [] })
  });

  useEffect(() => {
    if (staff && Array.isArray(staff)) {
      bankStore.setStaff(staff);
      bankStore.toggleStaffLoaded(true);
    }
  }, [staff]);

  return { staff, isLoadingStaff };
}
